export const replacePathname = (url: string, title: string = "Pag Online") => {
  if (window.history.replaceState) {
    window.history.replaceState("location", title, url);
  }
};
